import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';

import { SapC4CLinkedService } from 'app/model/linkedservice/sapc4c.linkedservice';
import { TabularTypeDataset } from './tabular-type.dataset';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.sapc4c.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.SapCloudForCustomer_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.SapCloudForCustomer_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: SapC4CLinkedService.MODEL // Linked service redefined
        }
    }
})
export class SapC4CResourceDataset extends TabularTypeDataset {
    public static readonly MODEL: IModel;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
